var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("label", { staticClass: "control-label name column-nowrap" }, [
      _c("div", { staticClass: "label-form" }, [
        _c("div", { staticClass: "label-title" }, [
          _vm._v(
            "\n                " + _vm._s(_vm.inputLabel) + "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("span", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.number",
            value: _vm.value,
            expression: "value",
            modifiers: { number: true },
          },
        ],
        staticClass: "form-control",
        class: _vm.inputClass,
        attrs: { type: "number", min: "1", id: _vm.inputId },
        domProps: { value: _vm.value },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.value = _vm._n($event.target.value)
            },
            _vm.valueChanged,
          ],
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }